export interface QuickAction {
  id: string;
  label: string;
  prompt: string;
}

export const DEFAULT_QUICK_ACTIONS: readonly QuickAction[] = [
  {
    id: 'resolve-requests',
    label: 'Resolve requests',
    prompt: 'Help me resolve the open requests for this patient.',
  },
  {
    id: 'order-prescription',
    label: 'Order a prescription',
    prompt: 'I need to order a prescription for this patient.',
  },
  {
    id: 'summarize-chart',
    label: 'Summarize chart',
    prompt: "Give me a concise summary of this patient's chart.",
  },
] as const;
